import { Component, ViewContainerRef, ViewEncapsulation, OnInit } from '@angular/core';
import { ToastsManager } from 'ng2-toastr/ng2-toastr';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.pug',
  styleUrls: ['./app.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class AppComponent implements OnInit {
  public title = 'app works!';

  constructor(public toastr: ToastsManager,
              public vRef: ViewContainerRef) {
    this.toastr.setRootViewContainerRef(vRef);
  }

  ngOnInit() {
    $(window).on('scroll load', function() {
      $('.fade-content > *').each(function() {
        let objectBottom = $(this).offset().top + $(this).outerHeight() / 8;
        let windowBottom = $(window).scrollTop() + $(window).height();
        if (windowBottom > objectBottom) {
          $(this).css({'opacity': '1', 'transform': 'translateY(0em)'});
        } else {
          $(this).css({'opacity': '0', 'transform': 'translateY(2em)'});
        }
      })
      if (sessionStorage.fonts) {
        $('html').addClass('wf-active');
      }
    });
  }

  closeMenu() {
    $('body').removeClass('sidemenu-open');
  }
}



// WEBPACK FOOTER //
// ./src/app/app.component.ts